<template>
  <div class="auth-login password-change">
    <section class="password-change__content">
      <router-link class="auth-login__logo" :to="{name: 'Home'}">
        <img src="@/assets/images/logo.svg" alt="logo" />
      </router-link>
      <el-form :model="form" :rules="rules" ref="form" class="auth-card" :validate-on-rule-change="false" @submit.prevent.native="onSubmit">
        <h1 class="auth-login__title mt-0">Смена пароля</h1>
        <div class="auth-login__error w-75 mx-auto mt-4">
          Возможная причина попадания на этот экран: ваш пароль истек или не соответствует критериям. Смените его.
        </div>

        <div class="row mt-4 d-flex align-items-center">
          <div class="col-12 col-md-7">
            <h4>
              Пароль должен отвечать следующим критериям:
            </h4>
            <ul>
              <li v-for="(criterion, ind) in passwordCriteria" class="text-break-spaces" :key="ind">{{criterion}}</li>
            </ul>
          </div>
          <div class="col-12 col-md-5">
            <el-form-item prop="login" class="auth-login__item" :class="{'is-error': showError}">
              <el-input :value="form.login" />
              <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.login) }">Email</span>
            </el-form-item>
            <el-form-item prop="password" class="auth-login__item" :class="{'is-error': showError}">
              <el-input v-model="form.password" show-password />
              <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.password) }">Текущий пароль</span>
            </el-form-item>
            <el-form-item prop="newPassword" class="auth-login__item" :class="{'is-error': showError}">
              <el-input v-model="form.newPassword" show-password />
              <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.newPassword) }">Новый пароль</span>
            </el-form-item>
            <el-form-item prop="repeatNewPassword" class="auth-login__item" :class="{'is-error': showError}">
              <el-input v-model="form.repeatNewPassword" show-password />
              <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.repeatNewPassword) }">Повторите новый пароль</span>
            </el-form-item>
          </div>
        </div>

        <div class="auth-login__actions row justify-content-center">
          <div class="col-6 col-md-3">
            <el-button @click="onCancel" class="w-100" :disabled="loading">Отмена</el-button>
          </div>
          <div class="col-6 col-md-3 offset-md-1">
            <el-button type="primary" @click="onSubmit" class="w-100" :disabled="loading">Сменить пароль</el-button>
          </div>
        </div>
      </el-form>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import passwordCriteria from '@/commons/constants/passwordCriteria';
import { validatePassword, validatePasswordMatch } from '@/commons/validators';

export default {
  data: () => ({
    passwordCriteria,
    showError: false,
    form: {
      login: '',
      password: '',
      newPassword: '',
      repeatNewPassword: '',
    },
  }),

  computed: {
    ...mapGetters({
      loading: 'account/passwordResetProgress',
      currentUserLogin: 'auth/currentUserLogin',
    }),
    rules() {
      return {
        login: [
          { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
          { type: 'email', message: MESSAGES.INCORRECT_EMAIL, trigger: 'blur' },
        ],
        password: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
        newPassword: [
          { validator: validatePassword(this.form.password), trigger: 'change' },
        ],
        repeatNewPassword: [
          { validator: validatePasswordMatch(this.form.newPassword), trigger: 'change' },
        ],
      };
    },
  },

  methods: {
    ...mapMutations({
      logoutUser: 'auth/logoutUser',
    }),
    ...mapActions({
      passwordReset: 'account/passwordReset',
    }),
    onCancel() {
      if (this.$user) {
        this.$router.replace({ name: 'Home' });
      } else {
        this.$router.replace({ name: 'Login' });
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.passwordReset(this.form)
            .then(() => {
              this.logoutUser();
              this.$router.replace({ name: 'Login' });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
  },
  created() {
    // Редиректить со страницы смены пароля в случае если нет емейла юзера из предыдущей успешной авторизанции или из профиля
    if (!this.currentUserLogin) {
      this.$router.replace('Login');
      return false;
    }
    this.form.login = this.currentUserLogin;
  },
};
</script>
<style lang="scss" scoped>
@import "src/assets/styles/variables";
.password-change {
  &__content {
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

.auth-card {
  max-width: 920px;
}
</style>
